import {Component, OnInit} from '@angular/core';
import {HomeService} from "./home.service";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-index',
    templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
    source = 'web';
    constructor(private homeService: HomeService, private activatedRoute: ActivatedRoute) {
        this.activatedRoute.queryParams.subscribe(params => {
            this.source = params['source'];
        });
    }

    clicked = false;

    timeArr = [
        '00:00',
        '00:10',
        '00:20',
        '00:30',
        '00:40',
        '00:50',
        '01:00',
        '01:10',
        '01:20',
        '01:30',
        '01:40',
        '01:50',
        '02:00',
        '02:10',
        '02:20',
        '02:30',
        '02:40',
        '02:50',
        '03:00',
        '03:10',
        '03:20',
        '03:30',
        '03:40',
        '03:50',
        '04:00',
        '04:10',
        '04:20',
        '04:30',
        '04:40',
        '04:50',
        '05:00',
        '05:10',
        '05:20',
        '05:30',
        '05:40',
        '05:50',
        '06:00',
        '06:10',
        '06:20',
        '06:30',
        '06:40',
        '06:50',
        '07:00',
        '07:10',
        '07:20',
        '07:30',
        '07:40',
        '07:50',
        '08:00',
        '08:10',
        '08:20',
        '08:30',
        '08:40',
        '08:50',
        '09:00',
        '09:10',
        '09:20',
        '09:30',
        '09:40',
        '09:50',
        '10:00',
        '10:10',
        '10:20',
        '10:30',
        '10:40',
        '10:50',
        '11:00',
        '11:10',
        '11:20',
        '11:30',
        '11:40',
        '11:50',
        '12:00',
        '12:10',
        '12:20',
        '12:30',
        '12:40',
        '12:50',
        '13:00',
        '13:10',
        '13:20',
        '13:30',
        '13:40',
        '13:50',
        '14:00',
        '14:10',
        '14:20',
        '14:30',
        '14:40',
        '14:50',
        '15:00',
        '15:10',
        '15:20',
        '15:30',
        '15:40',
        '15:50',
        '16:00',
        '16:10',
        '16:20',
        '16:30',
        '16:40',
        '16:50',
        '17:00',
        '17:10',
        '17:20',
        '17:30',
        '17:40',
        '17:50',
        '18:00',
        '18:10',
        '18:20',
        '18:30',
        '18:40',
        '18:50',
        '19:00',
        '19:10',
        '19:20',
        '19:30',
        '19:40',
        '19:50',
        '20:00',
        '20:10',
        '20:20',
        '20:30',
        '20:40',
        '20:50',
        '21:00',
        '21:10',
        '21:20',
        '21:30',
        '21:40',
        '21:50',
        '22:00',
        '22:10',
        '22:20',
        '22:30',
        '22:40',
        '22:50',
        '23:00',
        '23:10',
        '23:20',
        '23:30',
        '23:40',
        '23:50'
    ];
    booking = {
        submit_date: '',
        name: '',
        email: '',
        ic_or_passport_number: '',
        contact_number: '',
        car: '',
        pick_up_date: '',
        pick_up_time: '',
        return_date: '',
        return_time: '',
        return_location: '',
        pick_up_location: '',
        customer_from_location: '',
        customer_from_other_location: '',
        promo_code: '',
        how_did_you_know_about_us: '',
        source: 'web',
    };
    enquiry = {
        name: '',
        contact_number: '',
        message: ''
    };

    ngOnInit() {
        const today = new Date();
        const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        this.booking.submit_date = date + ' ' + time;
    }


    send() {
        this.homeService.saveToGoogleSpreadSheet(this.booking).subscribe((dat2a) => {
            this.clicked = false;
        });
    }

    sendBooking() {
        this.clicked = true;
        if(this.source){
            this.booking.source = this.source;
        }
        this.send();
        let myMessage = 'Hello, I would like to make a booking' +
            '\nName : ' + this.booking.name +
            '\nPhone Number : ' + this.booking.contact_number +
            '\nEmail : ' + this.booking.email +
            '\nIC / Passport Number : ' + this.booking.ic_or_passport_number +
            '\nVehicle Type : ' + this.booking.car +
            '\nPick Up Date : ' + this.booking.pick_up_date +
            '\nPick Up Time : ' + this.booking.pick_up_time +
            '\nReturn Date : ' + this.booking.return_date +
            '\nReturn Time : ' + this.booking.return_time +
            '\nPick Up Location : ' + this.booking.pick_up_location +
            '\nReturn Location : ' + this.booking.return_location +
            '\nCustomer Origin Location : ' + this.booking.customer_from_location +
            '\nHow did you know about us : ' + this.booking.how_did_you_know_about_us +
            '\nPromo Code : ' + this.booking.promo_code;

        if (this.booking.customer_from_other_location != '' && this.booking.customer_from_other_location != null) {
            myMessage += '\nCustomer Origin Location (Others) : ' + this.booking.customer_from_other_location;
        }

        if (this.source == 'qr') {
            window.open('https://wa.me/60189497157?text=' + encodeURIComponent(myMessage), '_blank');
        } else {
            window.open('https://wa.me/60109497157?text=' + encodeURIComponent(myMessage), '_blank');
        }
    }

    contactUs() {
        const myMessage = 'Enquiry' +
            '\nName : ' + this.enquiry.name +
            '\nContact Number : ' + this.enquiry.contact_number +
            '\nMessage : ' + this.enquiry.message;

        window.open('https://wa.me/60109497157?text=' + encodeURIComponent(myMessage), '_blank');
    }
}
